(() => {
  const initializeSortControl = (control) => {
    if (control.dataset.tiCollectionSortReady === 'true') return;

    const button = control.querySelector('[data-ti-collection-sort-button]');
    const label = control.querySelector('[data-ti-collection-sort-label]');
    const menu = control.querySelector('[data-ti-collection-sort-menu]');
    const nativeSelect = control.querySelector('[data-ti-collection-sort-native]');
    const options = Array.from(control.querySelectorAll('[data-ti-collection-sort-option]'));

    if (!button || !label || !menu || !nativeSelect || !options.length) return;

    const selectedIndex = () =>
      Math.max(
        0,
        options.findIndex((option) => option.dataset.value === nativeSelect.value),
      );

    const closeMenu = ({ returnFocus = false } = {}) => {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (returnFocus) button.focus();
    };

    const openMenu = ({ focus = 'selected' } = {}) => {
      menu.hidden = false;
      button.setAttribute('aria-expanded', 'true');

      const targetIndex = focus === 'first' ? 0 : focus === 'last' ? options.length - 1 : selectedIndex();
      options[targetIndex]?.focus();
    };

    const updateSelection = (option) => {
      const changed = nativeSelect.value !== (option.dataset.value || '');
      nativeSelect.value = option.dataset.value || '';
      label.textContent = option.textContent.trim();
      options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      closeMenu({ returnFocus: true });

      if (changed) nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const moveFocus = (option, direction) => {
      const currentIndex = options.indexOf(option);
      const nextIndex = Math.min(options.length - 1, Math.max(0, currentIndex + direction));
      options[nextIndex]?.focus();
    };

    const currentOption = options[selectedIndex()];
    if (currentOption) {
      label.textContent = currentOption.textContent.trim();
      options.forEach((option) => option.setAttribute('aria-selected', String(option === currentOption)));
    }

    button.addEventListener('click', () => {
      if (menu.hidden) openMenu();
      else closeMenu();
    });

    button.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openMenu({ focus: event.key === 'ArrowDown' ? 'first' : 'last' });
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => updateSelection(option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          moveFocus(option, event.key === 'ArrowDown' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          options[event.key === 'Home' ? 0 : options.length - 1]?.focus();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu({ returnFocus: true });
        } else if (event.key === 'Tab') {
          closeMenu();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!control.contains(event.target)) closeMenu();
    });

    control.dataset.tiCollectionSortReady = 'true';
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll?.('[data-ti-collection-sort]').forEach(initializeSortControl);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
